import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import Reveal from './motion/Reveal';

const teamMembers = [
  {
    name: 'Patricia',
    role: 'Aesthetician',
    image: '/images/about/about-patricia.jpg',
    alt: 'Patricia - Colombian Body Contour Spa Professional',
    testId: 'team-patricia'
  },
  {
    name: 'Glendy',
    role: 'Cosmetology',
    image: '/images/about/about-team-member-2.png',
    alt: 'Glendy - Colombian Body Contour Spa Professional',
    testId: 'team-glendy'
  },
  {
    name: 'Michelle',
    role: 'Mani/Pedi',
    image: '/images/about/about-team-member-3.png',
    alt: 'Michelle - Manicure & Pedicure Specialist',
    testId: 'team-michelle'
  }
];

const About = () => {
  const { t } = useLanguage();

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Centered Header and Content */}
        <Reveal className="text-center max-w-3xl mx-auto mb-16 space-y-8">
          <div className="space-y-4">
            <h2 className="text-4xl font-normal text-black">
              {t.about.title}
            </h2>
            <div className="w-16 h-px bg-black mx-auto"></div>
          </div>

          <p className="text-lg text-gray-700 leading-relaxed">
            {t.about.description}
          </p>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-8 pt-8">
            <div className="space-y-2">
              <div className="text-3xl font-normal text-black">5.0</div>
              <div className="text-sm text-gray-600">Google Rating</div>
            </div>
            <div className="space-y-2">
              <div className="text-3xl font-normal text-black">15+</div>
              <div className="text-sm text-gray-600">Services</div>
            </div>
            <div className="space-y-2">
              <div className="text-3xl font-normal text-black">100%</div>
              <div className="text-sm text-gray-600">Satisfaction</div>
            </div>
          </div>
        </Reveal>

        {/* Side-by-Side Team Images */}
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {teamMembers.map((member, index) => (
            <Reveal key={member.name} delay={index * 0.12} className="relative" data-testid={member.testId}>
              <div className="aspect-square bg-gray-100 relative overflow-hidden border-2 border-black group">
                <img
                  src={member.image}
                  alt={member.alt}
                  className="w-full h-full object-contain transition-transform duration-700 ease-out group-hover:scale-[1.03]"
                />
              </div>
              <div className="text-center mt-4">
                <h3 className="text-lg font-normal text-black">{member.name}</h3>
                <p className="text-sm text-gray-600">{member.role}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
